(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-quote-request"] && !Shopify.designMode) return;
  try {
    (() => {
    const setSubmitLabel = (root) => {
      const label = root.getAttribute('data-submit-label');

      if (!label) {
        return;
      }

      root.querySelectorAll('button[type="submit"], .wizard__submit').forEach((button) => {
        const currentText = button.textContent.replace(/\s+/g, ' ').trim();

        if (button.dataset.quoteSubmitLabel === label && currentText === label) {
          return;
        }

        const spinner = button.querySelector('.spinner');

        button.textContent = '';

        if (spinner) {
          button.appendChild(spinner);
        }

        button.appendChild(document.createTextNode(label));
        button.dataset.quoteSubmitLabel = label;
        button.dataset.submitText = `<span class="spinner"></span>${label}`;
        button.setAttribute('aria-label', label);
      });
    };

    const setShowroomLinks = (root) => {
      const panel = root.closest('.product-quote-request');

      if (!panel) {
        return;
      }

      panel.querySelectorAll('a[href="/pages/showroom"]').forEach((link) => {
        link.setAttribute('href', '/pages/service-area');
      });
    };

    const isVisible = (element) => {
      if (!element) {
        return false;
      }

      const style = window.getComputedStyle(element);

      return style.display !== 'none' && style.visibility !== 'hidden';
    };

    const hasSuccessMessage = (root) => {
      return Array.from(root.querySelectorAll('.message.success, .wizard__congrats-message')).some((message) => {
        const text = message.textContent.replace(/\s+/g, ' ').trim().toLowerCase();

        return isVisible(message) && /thank|success|received|submitted|sent|getting in touch/.test(text);
      });
    };

    const setSuccessState = (root) => {
      const isSubmitted = hasSuccessMessage(root);
      const successMessage = root.querySelector('.product-quote-request__success');
      const panel = root.closest('.product-quote-request');

      root.classList.toggle('is-submitted', isSubmitted);
      panel?.classList.toggle('product-quote-request--submitted', isSubmitted);

      if (!successMessage) {
        return;
      }

      successMessage.hidden = !isSubmitted;

      if (isSubmitted && successMessage.dataset.quoteSuccessFocused !== 'true') {
        successMessage.dataset.quoteSuccessFocused = 'true';

        requestAnimationFrame(() => {
          successMessage.focus({ preventScroll: true });
        });
      }
    };

    const initQuoteForms = () => {
      document.querySelectorAll('.product-quote-request__app-form').forEach((root) => {
        setShowroomLinks(root);
        setSubmitLabel(root);
        setSuccessState(root);

        if (root.dataset.quoteSubmitObserver === 'true') {
          return;
        }

        root.dataset.quoteSubmitObserver = 'true';

        new MutationObserver(() => {
          setShowroomLinks(root);
          setSubmitLabel(root);
          setSuccessState(root);
        }).observe(root, { childList: true, subtree: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initQuoteForms, { once: true });
    } else {
      initQuoteForms();
    }

    document.addEventListener('shopify:section:load', initQuoteForms);
  })();
  } catch(e) { console.error(e); }
})();

})();
